import React from 'react';
import Menu from '../components/menu';
import Icon from '../elements/icons';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Helmet } from 'react-helmet';
import Carusel from '../components/carusel';

class SPFH extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        window.scrollTo(0, 0);
        return (<>
            <Helmet>
                <meta charSet="utf-8" />
                <title>SPFH - Lebenshilfe Rinteln</title>
                <meta
                    name="description"
                    content="Sozialpädagogische Familienhilfe (SPFH) der Lebenshilfe Rinteln. Ambulante Hilfe zur Erziehung. Wir begleiten Sie in Alltagssituationen bei Ihnen Zuhause."
                />
            </Helmet>

            <div style={{ marginTop: "100px" }} className="animate__animated animate__fadeIn pb-5">

                {this.props.mobileVersion ? "" : <Menu {...this.props} />}

                {/* Hero Section */}
                <div className="container text-center shadow p-0 rounded overflow-hidden mt-3">
                    <h3 className="p-3 text-white m-0 ff-1 shadow-sm" style={{ background: "linear-gradient(135deg, #dc3545, #a71d2a)" }}>Sozialpädagogische Familienhilfe (SPFH)</h3>
                    <Carusel
                        bilder={[
                            "assets/spfh/1.png",
                            "assets/spfh/2.png",
                            "assets/spfh/3.png",
                        ]}
                        height="450px" width="100%" className="" />
                </div>

                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="text-center ff-1 text-white shadow p-4 rounded mb-5" style={{ background: "linear-gradient(135deg, #dc3545, #a71d2a)" }}>
                                <h4 className="m-0" style={{ lineHeight: "1.5" }}>Die Lebenshilfe Rinteln e.V. freut sich zu verkünden, dass wir bald unser Angebot der ambulanten Dienste erweitern.<br /><br />Ab dem 01.05.2026 startet die sozialpädagogische Familienhilfe (SPFH).</h4>
                            </div>
                        </div>
                    </div>

                    <div className='row mb-5 d-flex align-items-stretch'>
                        <div className='col-md-6 mb-4 mb-md-0'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 custom-hover-card" style={{ borderLeft: "5px solid #dc3545" }}>
                                <h4 className="text-danger mb-3 d-flex align-items-center">
                                    <div className="mr-2"><Icon icon="FaHome" /></div> Begleitung im Zuhause
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>Die SPFH ist eine ambulante Hilfe zur Erziehung und begleitet Sie in Alltagssituationen bei Ihnen Zuhause.</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 custom-hover-card" style={{ borderLeft: "5px solid #ffc107" }}>
                                <h4 className="text-warning mb-3 d-flex align-items-center">
                                    <div className="mr-2"><Icon icon="FaHandsHelping" /></div> Selbstwirksamkeit stärken
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>Ziel ist es, Familien in ihrer Selbstwirksamkeit zu stärken und nachhaltige Entwicklungs- und Veränderungsprozesse zu ermöglichen.</p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Section */}
                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="text-dark rounded shadow p-4 p-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #ffc107, #ffb300)" }}>
                                <div className="mb-4 mb-md-0 flex-grow-1 pr-md-4">
                                    <h3 className="font-weight-bold mb-3 d-flex align-items-center">
                                        <div className="mr-2"><Icon icon="FaQuestionCircle" /></div> Haben Sie Interesse oder Fragen zum Angebot?
                                    </h3>
                                    <p className="mb-0" style={{ fontSize: "1.1rem" }}>Gerne beraten wir Sie zu den Möglichkeiten der sozialpädagogischen Familienhilfe (SPFH).</p>
                                </div>
                                <div className="ml-md-4">
                                    <Link to="/kontakt" className="btn btn-dark btn-lg shadow rounded px-4 py-3 font-weight-bold text-nowrap modern-btn">Kontakt aufnehmen</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Ansprechpartner Card */}
                    <div className="row m-0 justify-content-center mb-4">
                        <div className="col-12 col-lg-10 bg-white shadow rounded p-0 overflow-hidden contact-card">
                            <div className="bg-danger p-3 text-white text-center font-weight-bold" style={{ fontSize: "1.2rem", letterSpacing: "1px" }}>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="mr-2"><Icon icon="Person" /></div> Ihre Ansprechpartnerin
                                </div>
                            </div>
                            <div className="row m-0 p-4 p-md-5 align-items-center">
                                <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
                                    <div className="position-relative d-inline-block">
                                        <img src={"/assets/spfh/contact.jpeg"} className="rounded-circle shadow-sm" style={{ width: "200px", height: "200px", objectFit: "cover", border: "5px solid #fff" }} alt="Saskia Wasmann" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 text-center text-md-left text-secondary pl-md-4">
                                    <h2 className="text-dark font-weight-bold mb-1">Saskia Wasmann</h2>

                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mt-4" style={{ fontSize: "1.1rem" }}>
                                        <div className="bg-light rounded-circle p-2 mr-3 text-danger shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                                            <Icon icon="Phone" />
                                        </div>
                                        <span className="font-weight-bold text-dark">0152 – 092 091 56</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-4" style={{ fontSize: "1.1rem" }}>
                                        <div className="bg-light rounded-circle p-2 mr-3 text-danger shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                                            <Icon icon="Mail" />
                                        </div>
                                        <a href="mailto:spfh@lebenshilfe-rinteln.de" className="text-danger font-weight-bold" style={{ textDecoration: "underline" }}>spfh@lebenshilfe-rinteln.de</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Inline CSS for specific component styles */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .custom-hover-card {
                        transition: all 0.3s ease;
                        border: 1px solid #f8f9fa;
                    }
                    .custom-hover-card:hover {
                        transform: translateY(-8px);
                        box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important;
                        border-color: #e9ecef;
                    }
                    .modern-btn {
                        transition: all 0.2s ease;
                        border-radius: 50px !important;
                    }
                    .modern-btn:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,.2)!important;
                        background-color: #212529;
                    }
                    .contact-card { transition: all 0.3s ease; }
                    .contact-card:hover { box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important; }
                `}} />
            </div>
        </>);
    }
}

export default SPFH;
